import { CustomElement, getHtmlFromUrl } from '@/utils';

declare global {
  interface Window {
    EBWidgets: any;
  }
}

export default class EventButton extends CustomElement {
  static component = 'b-event-button';
  eventId: string;
  seriesId: string;

  init() {
    const eventId = this.getAttribute('event-id');
    const seriesId = this.getAttribute('series-id');

    if (!eventId) {
      return;
    }

    this.setAttribute('id', `event-${eventId}`);

    let script = document.querySelector('#eventbrite-widget-script');
    if (!script) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'eventbrite-widget-script';
      script.src = 'https://www.eventbrite.com/static/widgets/eb_widgets.js';
      script.async = true;
      script.onload = () => {
        this.load(eventId, seriesId);
      }
      document.head.appendChild(script);
    } else {
      this.load(eventId, seriesId);
    }
  }

  load(eventId: string, seriesId?: string) {
    window?.EBWidgets?.createWidget({
      widgetType: 'checkout',
      eventId: seriesId ? seriesId : eventId,
      modal: true,
      modalTriggerElementId: `event-${eventId}`,
    });
  }
}
